import { Table } from 'reactstrap'
import './AppObjectHistoryTable.css'

export default function AppObjectHistoryTable({ history }) {
  console.log('AppObjectHistoryTable rendered')
  const rows = []
  if (history) {
    history.forEach((historyRow, historyIndex) => {
      const row =
        <tr key={historyIndex}>
          <td>{historyRow.timeStamp}</td>
          <td>{historyRow.displayName}</td>
          <td>{historyRow.actionName}</td>
        </tr>
      rows.push(row)
    })
  }
  return (
    <Table className="app-object-history-table" bordered size="sm">
      <thead className="app-object-history-table-head">
        <tr>
          <th>Time Stamp</th>
          <th>User</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {rows}
      </tbody>
    </Table>
  )
}